<div>

    <button mat-button [matMenuTriggerFor]="menu" (click)="loadCart()"><span> <span *ngIf="products_count>0"
                                                                                    class="badge badge-light">{{products_count}}</span><i
            class="fa fa-shopping-cart"></i></span></button>

    <mat-menu #menu="matMenu">
        <div class="cart-icon-cont" (click)="$event.stopPropagation()">

            <div class="row mb-4">
                <div class="col-6">

                    <i class="la la-shopping-cart" i18n></i><br>
                    {{products_count}} <span i18n>items in cart</span></div>
                <div class="col-6" i18n> Cart Subtotal<br>
                    <b>{{current_currency}} {{(sum * rate) | number:this.registry.getSettingByID('price_format') }}</b>
                </div>

            </div>

            <button [routerLink]="'web/checkout-process'" (click)="removeSearchBarValue($event)" class="btn btn-success btn-block mb-4" style="font-size: 15px;" i18n>Continue to Checkout</button>
            <ul *ngIf="this.cart" class="cart-panel">
                <li *ngFor="let item of this.cart.items">

                    <div class="row">
                        <div class="col-2">

                            <img *ngIf="item.product ==null" src="assets/gray.png" width="40" height="40" />
                            <img *ngIf="item.product !=null" width="40" height="40"
                                 src="{{this.baseImageUrl}}/{{item.product.media_gallery_entries[0].file}}"/>
                        </div>
                        <div class="col-6">
                           <div>{{item.name}}</div>
                           <div style="font-weight: bold;">{{current_currency}} {{(item.price * rate ) | number:this.registry.getSettingByID('price_format')}}</div>

                        </div>
                        <div class="col-2">
                            {{item.qty}}
                        </div>
                        <div class="col-2">
                            <i class="fa fa-trash" (click)="removeCartItem(item)"></i>
                        </div>
                    </div>
                </li>
            </ul>

        </div>
    </mat-menu>

</div>
